import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getOnlyToken, ConfirmationAlert } from "./../../utils/commonFunctions";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import Loader from "../../common/Loader";

export default function Integrations() {
  const navigate = useNavigate();
  const [functions, setFunctions] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Fetch Custom Functions (same pattern you use)
  const fetchCustomFunctions = async () => {
    try {
      setLoading(true);
      const token = getOnlyToken();
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const res = await axios.get(
        "api/agents/custom-functions/create/",
        config
      );

      if (res.status === 200) {
        setFunctions(res.data.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch integrations", error);
      setFunctions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomFunctions();
  }, []);

  // 🔹 Actions
  const handleEdit = (row) => {
    navigate('/create-integration', { state: { editId: row.id } });
  };

  const handleDelete = (row) => {
    ConfirmationAlert(
      `Do you want to delete "${row.function_name}"?`,
      "Yes, Delete",
      async () => {
        try {
          const token = getOnlyToken();
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
          await axios.delete(`/api/agents/custom-functions/create/?id=${row.id}`, config);
          fetchCustomFunctions();
        } catch (error) {
          console.error("Failed to delete integration", error);
        }
      }
    );
  };

  // 🔹 Table Columns
  const columns = [
    {
      name: "S.No",
      width: "80px",
      cell: (row, index) => index + 1,
    },
    {
      name: "Function Name",
      selector: (row) => row.function_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Description",
      selector: (row) => row.function_description,
      wrap: true,
    },
    {
      name: "URL Type",
      wrap: true,
      center: true,
      cell: (row) => (row.url_type === "GET" ? (<span className="badge bg-success">GET</span>) : (<span className="badge bg-primary">POST</span>)
      ),
    },
    {
      name: "URL",
      wrap: true,
      cell: (row) =>
        row.url ? (
          <a
            href={row.url}
            target="_blank"
            rel="noreferrer"
            className="text-primary text-decoration-none"
          >
            {row.url}
          </a>
        ) : (
          "-"
        ),
    },
    {
      name: "Actions",
      width: "150px",
      center: true,
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          {/* Edit */}
          <button
            className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary"
            title="Edit"
            onClick={() => handleEdit(row)}
            style={{
              width: 34,
              height: 34,
              backgroundColor: "#7b99b1ff",
              color: "#fff",
            }}
          >
            <i className="bi bi-pencil"></i>
          </button>

          {/* Delete */}
          <button
            className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary"
            title="Delete"
            onClick={() => handleDelete(row)}
            style={{
              width: 34,
              height: 34,
              backgroundColor: "#ee8080ff",
              color: "#fff",
            }}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    }

  ];

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#064c77",
        borderBottom: "1px solid #dee2e6",
        minHeight: "52px",
      },
    },
    headCells: {
      style: {
        color: "#ffffff",
        fontSize: "13px",
        fontWeight: "700",
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "56px",
        backgroundColor: "#ffffff",
        "&:hover": {
          backgroundColor: "#f8f9fa",
          cursor: "pointer",
          transition: "all 0.2s ease",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#495057",
        borderBottom: "1px solid #f1f3f5",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #dee2e6",
        padding: "8px",
      },
    },
    noData: {
      style: {
        backgroundColor: "#ffffff",
        color: "#6c757d",
        padding: "24px",
      },
    },
  };


  return (
    <div id='layout-wrapper'>
      <Header />
      <Sidebar />
      <div className='page-content'>

        <div className="main-content">
          <div className="container-fluid py-4">
            {/* ===== Header ===== */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="fw-bold   mb-0">
                Custom Integrations
              </h2>

              <button
                onClick={() => navigate('/create-integration')}
                className="btn btn-primary  d-flex fs-6 align-items-center gap-1 px-2"
              >
                <i className="bi bi-plus fs-5"></i>
                Add Integration
              </button>
            </div>

            {/* ===== Data Table ===== */}
            <div className="card">
              <DataTable
                columns={columns}
                data={functions}
                progressPending={loading}
                progressComponent={
                  <div className='loader-overlay text-white'>
                    <Loader />
                  </div>
                }
                customStyles={customStyles}
                pagination
                responsive
                persistTableHead
                noDataComponent={
                  <div className="py-4 text-muted">
                    No integrations found
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
